import { Controller } from "@hotwired/stimulus";

// Never used "stable-coin" key for tooltip content?
const tooltipContent = {
    'stable-coin': 'Supported Networks: Polygon, Ethereum.<br>Supported Tokens: USDC, USDT, PYUSD.',
}

export default class RobustTableController extends Controller {

    showTooltip(event) {
        const tooltip = event.currentTarget.querySelector(".tooltip");
        if (tooltip) {
            tooltip.classList.remove("invisible", "opacity-0");
            tooltip.classList.add("opacity-100");
        }
    }

    hideTooltip(event) {
        const tooltip = event.currentTarget.querySelector(".tooltip");
        if (tooltip) {
            tooltip.classList.add("invisible", "opacity-0");
            tooltip.classList.remove("opacity-100");
        }
    }

    stopPropagation(event) {
        event.stopPropagation();
    }

    // Only the first branch arrives expanded. Rendering every branch's children
    // up front would pay the full query and payload cost to then hide most of it,
    // so the rest are fetched the first time they are opened and cached in the
    // DOM afterwards.
    async toggleGroup(event) {
        if (event.target.closest("a, button")) return;

        const row = event.currentTarget;
        const group = row.dataset.robustTableGroupParam;
        if (!group) return;

        const caret = row.querySelector("[data-branch-caret]");
        let rows = this.element.querySelectorAll(`tr[data-group="${group}"]`);

        if (!rows.length) {
            const src = row.dataset.robustTableSrcParam;
            if (!src || row.dataset.loading === "true") return;

            row.dataset.loading = "true";
            if (caret) caret.classList.add("opacity-30");
            try {
                const response = await fetch(src, { headers: { "X-Requested-With": "fetch" } });
                if (!response.ok) throw new Error(`status ${response.status}`);
                // Inserts HTML rendered by our own same-origin endpoint, the same trust level as a Turbo Stream.
                row.insertAdjacentHTML("afterend", await response.text()); // nosemgrep: typescript.react.security.audit.react-unsanitized-method.react-unsanitized-method
            } catch (error) {
                return;
            } finally {
                row.dataset.loading = "false";
                if (caret) caret.classList.remove("opacity-30");
            }
            if (caret) caret.classList.add("rotate-180");
            return;
        }

        const opening = rows[0].hidden;
        if (opening) {
            rows.forEach((sub) => { sub.hidden = false; });
        } else {
            this.collapseBranch(group);
        }
        if (caret) caret.classList.toggle("rotate-180", opening);
    }

    // Descendants live in their own groups, so hiding only the direct children
    // would leave grandchildren on screen under no visible parent. Their carets
    // are reset too, otherwise reopening the branch shows a collapsed row still
    // pointing down.
    collapseBranch(group) {
        this.element.querySelectorAll(`tr[data-group="${group}"]`).forEach((row) => {
            row.hidden = true;
            const caret = row.querySelector("[data-branch-caret]");
            if (caret) caret.classList.remove("rotate-180");
            const child = row.dataset.robustTableGroupParam;
            if (child) this.collapseBranch(child);
        });
    }

    openRowLink(event) {
        // Buttons inside a row are their own action, never the row's. The ⋯ menu
        // renders its trigger and every item as a button, so without this a click
        // on "Refund payment" fires the action AND bubbles to here — the modal
        // opens and the row link immediately navigates the page out from under
        // it. toggleGroup already guards the same way.
        if (event.target.closest('a, button')) {
            return;
        }

        const url = event.currentTarget.dataset.robustTableUrlParam;

        if (url) {
            window.location = url;
        } else {
            console.error("Row link URL not found on the clicked element.", event.currentTarget);
        }
    }

    async fetchHref(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const href = button.dataset.href;

        if (!href) {
            console.error("Href not found on button element.", button);
            return;
        }

        const wasDisabled = button.disabled;
        button.disabled = true;

        try {
            const response = await fetch(href, { method: "GET" });

            const contentType = response.headers.get("Content-Type") || "";

            if (contentType.includes("turbo-stream")) {
                const html = await response.text();
                Turbo.renderStreamMessage(html);
            } else if (contentType.includes("application/json")) {
                const json = await response.json();
                Turbo.renderStreamMessage(json.data);
            }
        } catch (error) {
            console.error("Error fetching href:", error);
        } finally {
            if (!wasDisabled) {
                button.disabled = false;
            }
        }
    }

}